module.exports = __webpack_public_path__ + "img/RepGuide-Notebook-Tablet-Phone-Daniel.89b08696.png";